<template>
  <div>
    <EditForm
      ref="editForm"
      :disabled="isDisableEditForm"
      :evgPlanOrderCode="params.code"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-evgBiz-evgPlanOrder-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
